export type PeriodKey =
  | "all-time"
  | "this-month"
  | "last-month"
  | "this-quarter"
  | "last-quarter"
  | "this-year"
  | "last-year"
  | "custom";

export interface DateRange {
  from: string;
  to: string;
}

export const periodOptions: { key: PeriodKey; label: string }[] = [
  { key: "this-month", label: "This Month" },
  { key: "last-month", label: "Last Month" },
  { key: "this-quarter", label: "This Quarter" },
  { key: "last-quarter", label: "Last Quarter" },
  { key: "this-year", label: "This Year" },
  { key: "last-year", label: "Last Year" },
  { key: "custom", label: "Custom" },
];

function pad(n: number): string {
  return String(n).padStart(2, "0");
}

function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}

export function getDateRange(key: PeriodKey): DateRange | null {
  if (key === "custom" || key === "all-time") return null;

  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth(); // 0-indexed

  switch (key) {
    case "this-month":
      return {
        from: `${year}-${pad(month + 1)}-01`,
        to: todayISO(),
      };
    case "last-month": {
      const lm = month === 0 ? 11 : month - 1;
      const ly = month === 0 ? year - 1 : year;
      const lastDay = new Date(ly, lm + 1, 0).getDate();
      return {
        from: `${ly}-${pad(lm + 1)}-01`,
        to: `${ly}-${pad(lm + 1)}-${pad(lastDay)}`,
      };
    }
    case "this-quarter": {
      const qs = Math.floor(month / 3) * 3;
      return {
        from: `${year}-${pad(qs + 1)}-01`,
        to: todayISO(),
      };
    }
    case "last-quarter": {
      let qs = Math.floor(month / 3) * 3 - 3;
      let qy = year;
      if (qs < 0) {
        qs += 12;
        qy--;
      }
      const qe = qs + 2;
      const lastDay = new Date(qy, qe + 1, 0).getDate();
      return {
        from: `${qy}-${pad(qs + 1)}-01`,
        to: `${qy}-${pad(qe + 1)}-${pad(lastDay)}`,
      };
    }
    case "this-year":
      return { from: `${year}-01-01`, to: todayISO() };
    case "last-year":
      return { from: `${year - 1}-01-01`, to: `${year - 1}-12-31` };
  }
}
